import { Helmet } from 'react-helmet-async';
import { pageTitle } from '../../../util/pageTitles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Row, Col } from 'react-bootstrap';
import { withRouter } from '../../../util/withRouter';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import Header from '../../../components/Header/Header';
import RadioButton from '../../../components/RadioButton/RadioButton';
import { getTenant, setTenant, joinTenant, error } from '../TenantActions';
import { setSuccessMessage } from '../../App/ErrorsActions';
import throttle from '../../../util/throttle';

import './TenantConfig.scss';
import _ from 'lodash';

class TenantConfig extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      mode: 0,
      model: {}
    };

    this.getTenantThrottled = throttle(this.getTenant, 1000, this);
  }

  componentDidMount() {   
    if (!!this.props.tenant) {
      this.setTenantState();
    }
    this.getTenant();
  }

  componentDidUpdate(prevProps, prevState) {
    if (!_.isEqual(prevProps.tenant, this.props.tenant)) {
      this.setTenantState();
    }
  }

  setTenantState() {
    this.setState({
      model: { ...this.state.model, ...this.props.tenant },
    });
  }

  getTenant() {
    this.props.getTenant();
  }

  handleSwitchMode = e => {
    this.setState({ mode: +e.value });
  }

  handleChange = e => {
    let target = e.target;
    const model = { ...this.state.model, [target.name]: target.value };
    this.setState({ model });
  }

  handleCreate = () => {
    if (this.validateCreate()) {
      this.props.setTenant(this.state.model);
    }
  }

  handleJoin = () => {
    if (this.validateJoin()) {
      this.props.joinTenant(this.state.model);
    }
  }

  handleCopied = () => {
    this.props.setSuccessMessage('Your organization tenant token has been copied to your clipboard');
  }

  validateCreate() {
    const { model } = this.state;
    if (!model.name) {
      this.props.setError('Tenant name is required');
      return false;
    }
    return true;
  }

  validateJoin() {
    const { model } = this.state;
    if (!model.name) {
      this.props.setError('Tenant name is required');
      return false;
    }
    if (!model.token) {
      this.props.setError('Tenant token is required');
      return false;
    }
    return true;
  }

  renderTenantOptions() {
    const { tenant } = this.props;
    const { mode } = this.state;

    if (!tenant || !tenant.saved) {
      return (
        <Row>
          <Col sm={12}>
            <Col sm={6}>
              <Form.Group controlId="mode-0">
                <RadioButton
                  id="mode-0"
                  name="mode-0"
                  label="Create organization tenant"
                  value="0"
                  checked={mode === 0}
                  disabled={tenant.saved}
                  onChange={this.handleSwitchMode}
                />
              </Form.Group>
            </Col>
            <Col sm={6}>
              <Form.Group controlId="mode-1">
                <RadioButton
                  id="mode-1"
                  name="mode-1"
                  label="Link this account to organization"
                  value="1"
                  checked={mode === 1}
                  disabled={tenant.saved}
                  onChange={this.handleSwitchMode}
                />
              </Form.Group>
            </Col>
          </Col>
          <Col sm={12}>
            <hr/>
          </Col>
        </Row>
      )
    }
  }

  render() {
    const { loading, tenant } = this.props;
    const { model, mode } = this.state;

    return [
      <Header key="1" title="" showHome={true} />,
      <div key="2" className='content-wrap'>
        <Helmet>
          <title>{pageTitle('Tenant')}</title>
        </Helmet>
        <div className='tenant_content'>
          { loading && (<div></div>) }
          { !loading && (
            <div className='white_box_details'>
              <h3>
                <span className={`check_mark ${tenant.saved ? 'green' : 'gray'}`}></span>
                { tenant.saved ? 'Your organization tenant is configured' : 'Configure organization tenant' }
              </h3>
              <Form className='form_tenant'>
                {this.renderTenantOptions()}
                <Row>
                  <Col sm={12}>
                    <Col sm={6}>
                      <Form.Group controlId="tenant-name">
                        <Form.Label>Organization tenant name</Form.Label>
                        <Form.Control
                          readOnly={tenant.saved}
                          style={{backgroundColor: tenant.saved ? '#f3f3f3' : ''}}
                          type="text"
                          name="name"
                          value={tenant.saved ? `https://${tenant.name.toLowerCase()}.getnave.com/` : model.name}
                          onChange={this.handleChange}
                        />
                      </Form.Group>
                    </Col>
                    { (!tenant || !tenant.saved && mode === 1) && (
                      <Col sm={6}>
                        <Form.Group controlId="tenant-token">
                          <Form.Label>Organization tenant token</Form.Label>
                          <Form.Control type="password" name="token" value={model.token} onChange={this.handleChange} />
                        </Form.Group>
                      </Col>
                    )}
                  </Col>
                </Row>
              </Form>

              { loading ? (
                <Button disabled>Loading...</Button>
              ) : tenant.saved ? (
                <CopyToClipboard
                  text={tenant.joinToken}
                  onCopy={this.handleCopied}
                >
                  <Button>Get join token</Button>
                </CopyToClipboard>
              ) : (
                <Button onClick={mode === 1 ? this.handleJoin : this.handleCreate}>
                  {mode === 1 ? 'Join organization' : 'Create organization'}
                </Button>
              )}

            </div>
          ) }
        </div>
      </div>
    ];
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setError: err => dispatch(error(err)),
    getTenant: () => dispatch(getTenant()),
    setTenant: (data) => dispatch(setTenant(data)),
    joinTenant: (url) => dispatch(joinTenant(url)),
    setSuccessMessage: msg => dispatch(setSuccessMessage(msg)),
  }
};

const mapStateToProps = state => {
  return {
    tenant: state.tenant.tenant,
    user: state.auth.user,
    loading: state.tenant.loading
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TenantConfig));
